<template>
  <b-container fluid>
    <b-overlay :show="loadingList">
    <b-row>
      <b-col lg="4" md="4" class="text-center">
        <span class="text-dark">
          {{ $t("sales_center.sales_center") }} : {{ getSalesCenterName(dataArray.sales_center_id) }}
        </span>
      </b-col>
      <b-col lg="8" md="8" class="text-center">
      </b-col>
      <b-col lg="4" md="4" class="text-center">
        <span class="text-dark" v-if="dataArray.product_type === 1">
          {{ $t("sales_distribution_admin.delivery_id") }} : {{ 'P - ' }} {{ dataArray.delivery_id }}
        </span>
        <span class="text-dark" v-else>
          {{ $t("sales_distribution_admin.delivery_id") }} : {{ 'W - ' }} {{ dataArray.delivery_id }}
        </span>
      </b-col>
      <b-col lg="4" md="4" class="text-center">
        <span class="text-dark">
          {{ $t("sales_distribution_admin.delivery_date") }} : {{ dataArray.delivery_date | dateFormat }}
        </span>
      </b-col>
      <b-col lg="4" md="4" class="text-center">
        <span class="text-dark">
          {{ $t('retailerManagement.manual_bill_no')}} : {{ dataArray.manual_bill_no }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mt-3">
        <b-col>
          <b-overlay :v-show="unitLoad">
            <table class="table table-bordered">
              <tr class="bg-light">
                <th width="100px">{{ $t("globalTrans.sl_no") }}</th>
                <th>{{ $t("production_store.pro_name") }}</th>
                <th>{{ $t("production_store.unit") }}</th>
                <th>{{ $t("sales_distribution_admin.delivered_quantity") }}</th>
                <th>{{ $t("sales_distribution_admin.unit_price") }}</th>
                <th>{{ $t("sales_distribution_admin.total_price") }}</th>
              </tr>
              <tr v-for="(item, index) in dataArray.details" :key="index">
                <td>{{ $n(index + 1) }}</td>
                <td>{{ productNameById(item.product_id) }}</td>
                <td>{{ unitNameById(item.unit_id) }}</td>
                <td>{{ $n(item.quantity) }}</td>
                <td>{{ $n(item.unit_price) }}</td>
                <td>{{ $n(item.total_price) }}</td>
              </tr>
              <tr>
                  <td colspan="5" class="text-right">{{ $t('sales_distribution_admin.grand_total') }}</td>
                  <td>{{ $n(getTotal(dataArray.details)) }}</td>
              </tr>
            </table>
          </b-overlay>
        </b-col>
    </b-row>
  </b-overlay>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: ['id'],
  data () {
    return {
      dataArray: {
        product_type: 1,
        sales_center_id: '',
        d_id: '',
        delivery_id: '',
        delivery_date: '',
        delivery_location: '',
        manual_bill_no: '',
        contact_no: '',
        comment: '',
        comment_bn: '',
        details: []
      },
      productList: {},
      unitLoad: false,
      sl: 0,
      loading: false
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getDeliveryDetails()
      this.dataArray.d_id = this.id
      this.dataArray.sales_center_id = tmp.sales_center_id
      this.dataArray.product_type = tmp.product_type
      this.dataArray.delivery_id = tmp.delivery_id
      this.dataArray.delivery_date = tmp.delivery_date
      this.dataArray.manual_bill_no = tmp.manual_bill_no
      this.dataArray.details = tmp.demand_details
      this.dataArray.delivery_location = tmp.delivery_location
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    categoryList: function () {
      return this.productCommonObj.productCategoryList.filter(
        (item) => item.status === 1
      )
    },
    salesCenterList: function () {
      return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  methods: {
    getDeliveryDetails () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
      return tmpData
    },
    getTotal (items) {
        let totalprice = 0
        Object.entries(items).forEach(([key, value]) => {
            totalprice = totalprice + parseInt(value.total_price)
        })
        return totalprice
    },
    cancel () {
      this.$bvModal.hide('modal-1')
    },
    productNameById (id) {
      const product = this.productCommonObj.productList.find(
        (product) => product.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return product.text_bn
      } else {
        return product.text_en
      }
    },
    unitNameById (id) {
      const unit = this.productCommonObj.productUnitList.find(
        (unit) => unit.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return unit.text_bn
      } else {
        return unit.text_en
      }
    },
    getSalesCenterName (id) {
      const salesCenter = this.salesCenterList.find(
        (salescenter) => salescenter.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return salesCenter.text_bn
      } else {
        return salesCenter.text_en
      }
    }
  }
}
</script>
